'use client';
import React from 'react';
import { Box, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import CommonContainer from '@components/CommonContainer';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import CommonDynamicVideo from '../CommonDynamicVideo';
import CommonDynamicButton from '../CommonDynamicButton';
import { Mobile } from '@components/Mobile';
import { Desktop } from '@components/Desktop';
import cn from './style.module.scss';
export default function WestminsterTowerBanner(
  props: MarketingPageComponentProps
) {
  return (
    <CommonDynamicVideo
      className={cn.westminsterTowerBanner}
      mobilePoster={props.images.westminster_tower_banner_story_mobile?.src}
      desktopPoster={props.images.westminster_tower_banner_story_desktop?.src}
      mobileVideo={props.videos?.westminsterTowerBannerstoryMobile?.src}
      desktopVideo={props.videos?.westminsterTowerBannerstoryDesktop?.src}
    >
      <CommonContainer
        paddingInline={{ xs: '32px', sm: '32px', md: '24px' }}
        maxWidth={{ xs: '100%', md: '1200px', lg: '1400px' }}
        flexGrow={1}
      >
        <Box className={cn.westminsterBannerContent}>
          <Box className={cn.westminsterBannerHeading}>
            <Mobile>
              <ParallaxText
                variant="h2"
                animationType="slideInBottom"
                animationDuration={500}
              >
                {ReactHtmlParser(
                  props.locale?.section?.westminsterTowerBannerHeadingMobile ||
                    ''
                )}
              </ParallaxText>
            </Mobile>
            <Desktop>
              <ParallaxText
                variant="h2"
                animationType="slideInBottom"
                animationDuration={500}
              >
                {ReactHtmlParser(
                  props.locale?.section?.westminsterTowerBannerHeadingDesktop ||
                    ''
                )}
              </ParallaxText>
            </Desktop>
          </Box>
          <CommonDynamicButton
            label={
              props.locale?.section?.westminsterTowerBannerButton ||
              'Register your interest'
            }
            scrollToId="westminsterTowerRegistrationID"
          />
        </Box>
      </CommonContainer>
      {/* <Box
        className={cn.westminsterTowerBannerTagline}
        sx={{
          backgroundImage: `url(${props.images.westminster_tower_dark_background?.src})`,
        }}
      >
        <ParallaxText
          variant="h2"
          animationType="slideInBottom"
          animationDuration={500}
        >
          {ReactHtmlParser(
            props.locale?.section?.westminsterTowerBannerTagLine || ''
          )}
        </ParallaxText>
      </Box> */}
    </CommonDynamicVideo>
  );
}
